import { firstValueFrom } from 'rxjs';

import { AppConfig } from '../interfaces/app-config';
import { AppConfigService } from '../services/app-config.service';

/**
 * Loads deploy-time backend config into memory before the app renders.
 *
 * Only fires when a token is already present, so it never races the OAuth `_et` exchange or trips
 * the 401 handler during the first-login window. In that window the fetch is simply skipped here and
 * backfilled later by `AppConfigService.ensureLoaded()` from the first authenticated view. Failures
 * are swallowed — config is best-effort and must not be able to block bootstrap.
 */
export function loadAppConfig(appConfigService: AppConfigService) {
  return async (): Promise<AppConfig | null> => {
    if (!localStorage.getItem('token')) {
      return null;
    }

    try {
      return await firstValueFrom(appConfigService.load());
    } catch {
      return null;
    }
  };
}
